import { OrderAction } from 'common/api/autogenerated/trading-gateway';

/**
 * This TypeScript function calculates the total cost of an order based on the amount, price, action
 * (defaulted to BUY), and maker commission.
 * @param {number} amount - The `amount` parameter represents the quantity of the order being placed.
 * It is a number value.
 * @param {number | undefined | null} price - The `price` parameter represents the unit price of the
 * item being ordered. It can be a number, `undefined`, or `null`.
 * @param {OrderAction} action - The `action` parameter in the `calculateOrderCost` function represents
 * the type of order action being performed, such as buying or selling. It has a default value of
 * `OrderAction.BUY`, which indicates a buy order.
 * @param {number} makerCommission - The `makerCommission` parameter in the `calculateOrderCost`
 * function represents the commission fee charged by the market maker for executing the order. This fee
 * is typically a percentage of the total order amount and is factored into the calculation of the
 * order cost based on whether the action is a buy or sell
 */
export const calculateOrderCost = (
  amount: number,
  price: number | undefined | null,
  // TODO: Fix this the next time the file is edited.

  action: OrderAction = OrderAction.BUY,
  makerCommission: number,
) => amount * (price ?? 0) * (action === OrderAction.BUY ? 1 + makerCommission : 1 - makerCommission);
